import apiFetch from '../../../utils/apiFetch';

export const commitCunningStrikeResolution = async (campaignId, payload) => {
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat/cunning-strike/resolve`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.reason || result.message || 'Cunning Strike could not be resolved.');
    error.payload = result;
    throw error;
  }
  return result;
};
